'use strict';

exports.RewardType = void 0;
(function (RewardType) {
    RewardType["FREEBIE"] = "Freebie";
    RewardType["OTHERS"] = "Other";
})(exports.RewardType || (exports.RewardType = {}));
exports.TEXTS = void 0;
(function (TEXTS) {
    TEXTS["FREE"] = "Free";
})(exports.TEXTS || (exports.TEXTS = {}));
exports.HideOverlayBottonType = void 0;
(function (HideOverlayBottonType) {
    HideOverlayBottonType["LEFT"] = "left";
    HideOverlayBottonType["RIGHT"] = "right";
})(exports.HideOverlayBottonType || (exports.HideOverlayBottonType = {}));
//# sourceMappingURL=types.js.map
